/**
 * Enum chuyển khoản, tiền mặt tại kho bạc, tiền mặt tại ngân hàng
 * ndchien1 - 23/8/2024
 */
export default {
  Transfer: 1,
  CashAtKB: 2,
  CashAtNH: 3,
  None: 0,
};
